var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnConsultation = function SvgIAvnConsultation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45.426h.689c.277 0 .501.225.501.502v1.951a2.608 2.608 0 0 1-5.214 0V.928C.426.65.651.426.928.426h.696",
    stroke: "#002774",
    strokeWidth: 0.852,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.034 5.485v2.69a1.624 1.624 0 0 0 3.247 0V7.27",
    stroke: "#002774",
    strokeWidth: 0.852,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.05,
    cx: 6.3,
    cy: 7.4,
    fill: "#002774",
    "data-no-stroke": "true"
  })));
};
export { SvgIAvnConsultation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTQuNDQ5OTIgMC40MjYyMDhINS4xMzg1OUM1LjQxNTUxIDAuNDI2MjA4IDUuNjQwMDEgMC42NTA3IDUuNjQwMDEgMC45Mjc2MjRWMi44NzkxMkM1LjY0MDAxIDQuMzE4MzcgNC40NzMxMyA1LjQ4NjggMy4wMzIzMyA1LjQ4NjhDMS41OTMwOCA1LjQ4NTI1IDAuNDI2MjA4IDQuMzE4MzcgMC40MjYyMDggMi44NzkxMlYwLjkyNzYyNUMwLjQyNjIwOCAwLjY1MDcwMSAwLjY1MDcgMC40MjYyMDggMC45Mjc2MjQgMC40MjYyMDhIMS42MjQwNCIKICAgICAgICBzdHJva2U9IiMwMDI3NzQiIHN0cm9rZS13aWR0aD0iMC44NTI0MDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8cGF0aCBkPSJNMy4wMzM5NCA1LjQ4NTE3VjguMTc0ODZDMy4wMzM5NCA5LjA3MDkxIDMuNzYxMyA5Ljc5ODI3IDQuNjU3MzUgOS43OTgyN0M1LjU1MzQgOS43OTgyNyA2LjI4MDc2IDkuMDcwOTEgNi4yODA3NiA4LjE3NDg2VjcuMjY5NTMiIHN0cm9rZT0iIzAwMjc3NCIKICAgICAgICAgIHN0cm9rZS13aWR0aD0iMC44NTI0MDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8Y2lyY2xlIHI9IjEuMDUiIGN4PSI2LjMiIGN5PSI3LjQiIGZpbGw9IiMwMDI3NzQiIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIi8+Cjwvc3ZnPgo=";